<template>
  <div>
    <template v-for="item in items">
      <el-menu-item
        :index="item.key"
        :key="item.key"
        v-if="!item.children"
        :route="item"
      >
        <svg-icon
          :icon-class="item.icon"
          v-if="item.icon"
          class="menu-icon"
        ></svg-icon>
        <span slot="title">
          {{ item.label }}
          <span class="badge" v-if="item.numberFun && item.number">
            {{ item.number }}
          </span>
        </span>
      </el-menu-item>
      <el-submenu :index="item.key" :key="item.key" v-else>
        <div class="" slot="title">
          <svg-icon
            :icon-class="item.icon"
            class="menu-icon"
            v-if="item.icon"
          ></svg-icon>
          <span>
            {{ item.label }}
            <span class="badge" v-if="item.number">{{ item.number }} </span>
          </span>
        </div>
        <submenu :items="item.children" />
      </el-submenu>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import Submenu from "./submenu.vue";

export default {
  name: "Submenu",
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    openeds: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    Submenu,
  },
  created() {
    this.items.forEach((item) => {
      if (item.numberFun) {
        this.computeNumber(item);
      }
    });
  },
  methods: {
    async computeNumber(item) {
      const self = this;
      if (item.numberFun) {
        let res = await item.numberFun();
        let number = res.data > 9999 ? "9999+" : res.data;
        Vue.set(item, "number", number);
        // 广播接收
        for (const emitName of item.emitNames) {
          self.$eventHub.$on(emitName, async () => {
            let res2 = await item.numberFun();
            let number2 = res2.data > 9999 ? "9999+" : res2.data;
            Vue.set(item, "number", number2);
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.badge {
  background: red;
  color: #fff;
  font-size: 12px;
  border-radius: 8px;
  padding: 0 5px;
  margin-left: 10px;
  vertical-align: middle;
}
.menu-icon {
  margin-right: 7px;
}
</style>